/**
 * WP-V2-TW — prostokąty kolizji Town (PLAN-V2 §4: colliders z pliku sceny).
 * Konsumowane przez WalkController — nie blokują proximity wejść (stoją „przed” budynkiem).
 */
import type { ColliderRect } from '../../core/world/types.js';
import { TOWN_BUILDING_HOTSPOTS, TOWN_GARDEN_GATE } from './hotspots.js';

/**
 * Bloki budynków / płotów — AABB lewy-górny róg.
 * Gracz chodzi przed fasadami (y wyższe = bliżej dołu ekranu).
 */
export function buildTownColliders(): ColliderRect[] {
  const blocks: ColliderRect[] = [];

  for (const h of TOWN_BUILDING_HOTSPOTS) {
    // bryła budynku nad przyciskiem wejścia
    blocks.push({
      x: h.x - 55,
      y: h.y - 130,
      width: 110,
      height: 90,
    });
  }

  // fontanna — Rynek (środek ~1600)
  blocks.push({ x: 1560, y: 360, width: 80, height: 50 });

  // płot osiedla
  blocks.push({ x: 200, y: 430, width: 400, height: 24 });

  // brama ogrodu (słupki) — przejście między słupkami
  blocks.push({
    x: TOWN_GARDEN_GATE.x - 90,
    y: TOWN_GARDEN_GATE.y - 100,
    width: 36,
    height: 160,
  });
  blocks.push({
    x: TOWN_GARDEN_GATE.x + 54,
    y: TOWN_GARDEN_GATE.y - 100,
    width: 36,
    height: 160,
  });

  // stajnia — zagroda
  blocks.push({ x: 2500, y: 300, width: 140, height: 40 });

  return blocks;
}
